import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store"; // Ensure store is properly typed
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore, Persistor } from "redux-persist";
import { EditModeProvider } from "./context/EditModeContext";

// Create the root element
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Create a persistor instance
let persistor: Persistor = persistStore(store);

root.render(
  <Provider store={store}>
    <EditModeProvider>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
    </EditModeProvider>
  </Provider>
);

reportWebVitals();
